import { produce } from 'immer';

import { CUSTOM_FIELD_VALUES_ACTION_TYPE } from '../actions/customFieldValues.actions';

const initialState = {
  byApplicationId: {},
  loadingByApplicationId: {},
};

const customFieldValuesReducer = produce((draft, { type, payload }) => {
  switch (type) {
    case CUSTOM_FIELD_VALUES_ACTION_TYPE.SET_CUSTOM_FIELD_VALUES:
      draft.byApplicationId[payload.applicationId] = payload.values;
      break;

    case CUSTOM_FIELD_VALUES_ACTION_TYPE.SET_LOADING:
      draft.loadingByApplicationId[payload.applicationId] = !!payload.isLoading;
      break;

    default:
      return draft;
  }
}, initialState);

export default customFieldValuesReducer;
